import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";
import { BoardContext, SocketContext } from "../../../context";
import { MainButton } from "../../atoms";

const AlertBox: FC<{}> = () => {
    const { t } = useTranslation();
    const { finishActionCardSocketEvent } = useContext(SocketContext);
    const { areYouSureBoxRendered, setAreYouSureBoxRendered } = useContext(BoardContext);

    const executeSelectedFunction = () => {

        switch(areYouSureBoxRendered.pendingFunctionName){
            case "finishActionCardSocketEvent": finishActionCardSocketEvent();
        }

        closeTheAreYouSureBox();
    }

    const closeTheAreYouSureBox = () => {
        setAreYouSureBoxRendered({isBoxActive: false, pendingFunctionName: "", message: ""});
    }

    return (
        <div className="center_horizontally_and_vertically full_screen_vw_vh">
            <div className="alert_box_wrapper">
                <div className="alert_box_text" > 
                    {areYouSureBoxRendered.message} 
                </div> 
                <div className="alert_box_buttons">
                    <div className="alert_box_button_width"> <MainButton text={t("cancelText")} type="big" clickHandler={() => closeTheAreYouSureBox() } /> </div>
                    <div className="alert_box_button_width"> <MainButton text={t("yesText")} type="big" clickHandler={() => executeSelectedFunction() } /> </div>
                </div>
            </div>    
        </div>  
    )
}

export default AlertBox;